<template>
  <div data-tour-id="samples-list-component-root">
    <div class="summary-header" data-tour-id="samples-list-header">
      <div class="summary-title">
        <div class="summary-icon"></div>
        <div class="summary-text">{{ $t('SamplesRegister') }}</div>
      </div>
    </div>

    <div data-tour-id="samples-list-grid">
      <DxDataGrid
        :data-source="store"
        :show-borders="false"
        :show-column-lines="false"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-column-headers="true"
        :show-colon="false"
        :remote-operations="true"
        :load-panel="{ enabled: false }"
        :hover-state-enabled="false"
        :show-row-lines="false"
        :row-alternation-enabled="false"
        :no-data-text="$t('noDataText')"
        class="custom-grid custom-invoice-list"
        @content-ready="init"
        @toolbar-preparing="onToolbarPreparing($event)"
      >
        <DxScrolling mode="standard" />
        <DxStateStoring
          :enabled="true"
          type="custom"
          storage-key="InvoiceListTable"
          :custom-load="loadState"
          :custom-save="customSave"
        />
        <DxPaging :page-size="10" />
        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[5, 10, 20]"
          :show-info="true"
          info-text="{2} items"
          :visible="true"
        />

        <DxSearchPanel
          :visible="true"
          :width="300"
          :placeholder="$t('search')"
        />

        <DxColumn
          data-field="CodAlbaran"
          :caption="$t('SamplesList.numberOfDeliveryNote')"
          :allow-sorting="true"
          :fixed="true"
          fixed-position="left"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="Estado"
          :caption="$t('SamplesList.status')"
          :fixed="true"
          alignment="center"
          fixed-position="center"
          :allow-header-filtering="false"
          cell-template="cellTemplateStatus"
        />
        <DxColumn
          data-field="NumMuestras"
          :caption="$t('SamplesList.numberOfSamples')"
          :allow-sorting="true"
          :fixed="true"
          fixed-position="center"
          alignment="center"
          :allow-header-filtering="false"
        />
        <DxColumn
          :caption="$t('SamplesList.agency')"
          :calculate-cell-value="getAgenciaDisplay"
          :allow-sorting="true"
          :fixed="true"
          alignment="center"
          fixed-position="left"
          :allow-header-filtering="false"
        />
        <DxColumn
          data-field="FechaRecogida"
          :caption="$t('SamplesList.collectionDate')"
          :allow-sorting="true"
          :fixed="true"
          alignment="center"
          fixed-position="center"
          :allow-header-filtering="false"
          sort-order="desc"
          :sort-index="0"
          data-type="date"
          :format="$helpers.getDateFormat(company)"
        />
        <!-- <DxColumn
          data-field="TotalMuestras"
          :caption="$t('SamplesList.price')"
          :allow-sorting="true"
          :fixed="true"
          alignment="center"
          fixed-position="left"
          :allow-header-filtering="false"
          cell-template="priceTemplate"
        /> -->
        <!-- <DxColumn
          data-field="Total"
          :caption="$t('SamplesList.totalPrice')"
          :allow-sorting="true"
          :fixed="true"
          alignment="center"
          fixed-position="left"
          :allow-header-filtering="false"
          cell-template="totalPriceTemplate"
        /> -->
        <DxColumn
          :buttons="updatedEditButtons"
          :fixed="true"
          fixed-position="right"
          type="buttons"
          name="actionColumn"
        />
        <template #cellTemplateStatus="{ data }">
          <div
            :class="$helpers.getStatusClass(data.data.idEstado)"
            class="status-text"
            style="text-align: center"
          >
            {{ $t($helpers.getStatusTextKey(data.data.Estado)) }}
          </div>
        </template>
        <!-- <template #priceTemplate="{ data }">
          <span>
            {{
              formatAmount(
                data.data.TotalMuestras,
                getInvoiceCurrency(data.data)
              )
            }}
          </span>
        </template>
        <template #totalPriceTemplate="{ data }">
          <span>
            {{
              formatAmount(
                data.data.Total,
                getInvoiceCurrency(data.data)
              )
            }}
          </span>
        </template> -->
      </DxDataGrid>
    </div>
    <!-- <samplesListDetailsPopup
      v-if="showSplPopup"
      :store="invoiceSamples"
    /> -->
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxPager,
  DxPaging,
  DxScrolling,
  DxStateStoring,
} from 'devextreme-vue/data-grid';
import { mapActions, mapGetters, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import helpers from '@/js/helpers';
import Api from '@/services/Api';
import iconVisibility from '@/static/icons/ic_visibility.svg';
import iconDownload from '@/static/icons/ic_download.svg';
import iconTrash from '@/static/icons/ic_trash_new.svg';
import iconAddNew from '@/static/icons/ic_add_new.svg';
import iconDocumentTemplate from '@/static/icons/ic_document_template.svg';
import { emitSamplesRegisterGa4Event } from '@/services/samplesRegisterAnalytics';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxPager,
    DxPaging,
    DxScrolling,
    DxStateStoring,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
    forcedStatuses: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      editButtons: [],
      visible: true,
      selectedInvoiceStatuses: [], // p.ej. ['100','101']
      grid: null,
      invoiceCurrenciesById: {},
    };
  },
  computed: {
    updatedEditButtons() {
      return [
        {
          icon: iconVisibility,
          onClick: this.viewAtc,
          cssClass: 'grid-button-icon samples-list-detail-button',
        },
        {
          icon: iconAddNew,
          onClick: this.addSampleAtc,
          cssClass: 'grid-button-icon samples-list-add-sample-button',
          visible: (e) => e.row.data.Estado === 'Sin Enviar',
        },
        {
          icon: iconDownload,
          onClick: this.downloadInvoiceAtc,
          cssClass: 'grid-button-icon samples-list-download-button',
          visible: (e) => e.row.data.Estado !== 'Sin Enviar',
        },
        {
          icon: iconTrash,
          onClick: this.deleteAtc,
          cssClass: 'grid-button-icon samples-list-delete-button',
          disabled: (e) =>
            !['Sin Enviar', 'En Transito'].includes(
              e.row.data.Estado
            ),
          visible: (e) =>
            ['Sin Enviar', 'En Transito'].includes(e.row.data.Estado),
        },
      ];
    },
    ...mapState('contact', ['company']),
    ...mapGetters('contact', ['contactInfo']),
    ...mapState('samplesRegisterModule', [
      'showSplPopup',
      'invoiceSamples',
    ]),
  },

  watch: {
    forcedStatuses: {
      handler(value) {
        if (!Array.isArray(value) || !value.length) return;

        this.selectedInvoiceStatuses = value.map((status) =>
          String(status)
        );
      },
      deep: true,
    },
  },

  // Leemos los filtros seleccionados antes de crear la toolbar
  beforeMount() {
    if (this.forcedStatuses.length) {
      this.selectedInvoiceStatuses = this.forcedStatuses.map(
        (status) => String(status)
      );
      return;
    }

    const raw = localStorage.getItem('InvoiceListTable');
    if (raw) {
      try {
        const saved = JSON.parse(raw);
        if (saved.selectedInvoiceStatuses) {
          this.selectedInvoiceStatuses =
            saved.selectedInvoiceStatuses;
        }
      } catch (e) {
        console.warn('InvoiceListTable corrupto en localStorage', e);
      }
    }
  },

  mounted() {
    // Reaplicar filtro al entrar a la pantalla
    if (this.selectedInvoiceStatuses.length) {
      this.updateInvoiceFilter();
    }

    // this.hydrateInvoiceCurrencies();
  },

  methods: {
    emitGa4Event(eventName, eventParams = {}) {
      emitSamplesRegisterGa4Event(this, eventName, eventParams);
    },
    trackSamplesRegisterOpen(entryPoint) {
      // Entrada al registro desde el listado de albaranes.
      // Permite distinguir apertura para crear un albaran nuevo
      // frente a añadir muestras a un albaran ya existente.
      // Parametros distintivos:
      // - entry_point: create_invoice | add_sample_to_existing_invoice
      // - register_mode_default: el flujo arranca en modo standard
      this.emitGa4Event('samples_register_open', {
        entry_point: entryPoint,
        register_mode_default: 'standard',
      });
    },
    // ---- helper para construir el parámetro y llamar al backend ----
    updateInvoiceFilter() {
      if (!this.selectedInvoiceStatuses.length) {
        this.fetchAlbaranes('');
        return;
      }
      const valorAEnviar = `${this.selectedInvoiceStatuses.join(
        ','
      )}/`;
      this.fetchAlbaranes(valorAEnviar);
    },

    // guardar estado del grid + filtros en localStorage
    saveGridState() {
      if (!this.grid) return;
      const gridState = this.grid.state();
      this.customSave(gridState);
    },

    toggleStatus(code, element) {
      const idx = this.selectedInvoiceStatuses.indexOf(code);
      if (idx === -1) {
        this.selectedInvoiceStatuses.push(code);
        element.classList.add('show-icon');
        element.classList.remove('hide-icon');
      } else {
        this.selectedInvoiceStatuses.splice(idx, 1);
        element.classList.remove('show-icon');
        element.classList.add('hide-icon');
      }
      this.updateInvoiceFilter();
      this.saveGridState();
    },
    manageTemplates() {
      this.emitGa4Event('sampling_templates_list_open', {
        screen_name: 'TemplatesListPage',
        entry_point: 'samples_list_manage_templates_button',
      });
      this.$f7router.navigate(
        {
          name: 'TemplatesListPage',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    getAgenciaDisplay(rowData) {
      if (
        rowData.AgenciaLiteral &&
        rowData.AgenciaLiteral.trim() !== ''
      ) {
        return rowData.AgenciaLiteral;
      }
      if (rowData.Agencia === 'SIN AGENCIA') {
        return this.$t('SamplesList.noAgency');
      }
      return rowData.Agencia;
    },
    getInvoiceCurrency(rowData) {
      const invoiceId = rowData?.idAlbaran;
      const hydratedCurrency =
        invoiceId != null
          ? this.invoiceCurrenciesById[invoiceId]
          : null;

      return helpers.resolveCurrency({
        conversionX3: rowData?.ConversionX3,
        clientCurrency: this.contactInfo?.currency,
        additionalCurrencies: [hydratedCurrency],
        m: rowData?.M,
        moneda: rowData?.Moneda,
        fallback: 'EUR',
      });
    },
    formatAmount(amount, currency) {
      if (amount === null || amount === undefined || amount === '') {
        return '';
      }

      const parsedAmount = Number(
        typeof amount === 'string'
          ? amount.replace(',', '.').replace(/[^\d.-]/g, '')
          : amount
      );

      if (Number.isNaN(parsedAmount)) {
        return String(amount);
      }

      return new Intl.NumberFormat('es', {
        style: 'currency',
        currency: helpers.normalizeCurrency(currency) || 'EUR',
        minimumFractionDigits: 2,
      }).format(parsedAmount);
    },
    // async hydrateInvoiceCurrencies() {
    //   const invoices = Array.isArray(this.store) ? this.store : [];
    //   const invoiceIdsToLoad = invoices
    //     .map((invoice) => invoice?.idAlbaran)
    //     .filter(
    //       (invoiceId) =>
    //         invoiceId !== null &&
    //         invoiceId !== undefined &&
    //         this.invoiceCurrenciesById[invoiceId] === undefined
    //     );

    //   if (!invoiceIdsToLoad.length || !this.company) return;

    //   const results = await Promise.allSettled(
    //     invoiceIdsToLoad.map(async (invoiceId) => {
    //       const xhr = await Api.getInvoiceSamples(this.company, invoiceId);
    //       const response = JSON.parse(xhr.response);
    //       return {
    //         invoiceId,
    //         currency: helpers.getCurrencyFromInvoiceSamples(response),
    //       };
    //     })
    //   );

    //   const nextCurrencies = {};
    //   results.forEach((result) => {
    //     if (result.status !== 'fulfilled') return;
    //     nextCurrencies[result.value.invoiceId] = result.value.currency;
    //   });

    //   if (Object.keys(nextCurrencies).length) {
    //     this.invoiceCurrenciesById = {
    //       ...this.invoiceCurrenciesById,
    //       ...nextCurrencies,
    //     };
    //   }
    // },

    async viewAtc(e) {
      try {
        this.$f7.preloader.show();
        const selectedInvoiceId = e.row.data.idAlbaran;

        this.setSplPopupTitle(e.row.data.CodAlbaran);
        this.setInvoiceState(e.row.data.Estado);
        this.setInvoiceCode(e.row.data.CodAlbaran);
        this.setInvoiceDetails(e.row.data);

        await this.fetchInvoiceSamples(selectedInvoiceId);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
        this.$f7router.navigate(
          {
            name: 'InvoiceSamplesListDetails',
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      }
    },

    async openTourInvoiceDetail({
      onBeforeNavigateToInTransitDetails,
    } = {}) {
      const normalizeState = (state) =>
        typeof state === 'string'
          ? state
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '')
              .trim()
              .toLowerCase()
          : '';

      const isInTransit = (invoice) =>
        normalizeState(invoice?.Estado) === 'en transito';

      const visibleRows =
        typeof this.grid?.getVisibleRows === 'function'
          ? this.grid.getVisibleRows()
          : [];

      const visibleInvoices = visibleRows
        .filter((row) => row?.rowType === 'data')
        .map((row) => row?.data)
        .filter(Boolean);

      const firstVisibleInTransitInvoice = visibleInvoices.find(
        (invoice) => invoice?.idAlbaran && isInTransit(invoice)
      );
      const firstVisibleInvoice = visibleInvoices.find(
        (invoice) => invoice?.idAlbaran
      );

      const firstStoreInTransitInvoice = Array.isArray(this.store)
        ? this.store.find(
            (invoice) => invoice?.idAlbaran && isInTransit(invoice)
          )
        : null;
      const firstStoreInvoice = Array.isArray(this.store)
        ? this.store.find((invoice) => invoice?.idAlbaran)
        : null;

      const hasVisibleInvoices = visibleInvoices.length > 0;
      const firstInvoice = hasVisibleInvoices
        ? firstVisibleInTransitInvoice || firstVisibleInvoice
        : firstStoreInTransitInvoice || firstStoreInvoice;

      if (!firstInvoice?.idAlbaran) {
        return {
          opened: false,
          isInTransit: false,
        };
      }

      const selectedInvoiceIsInTransit = isInTransit(firstInvoice);

      try {
        this.$f7.preloader.show();
        this.setSplPopupTitle(firstInvoice.CodAlbaran);
        this.setInvoiceState(firstInvoice.Estado);
        this.setInvoiceCode(firstInvoice.CodAlbaran);
        this.setInvoiceDetails(firstInvoice);
        await this.fetchInvoiceSamples(firstInvoice.idAlbaran);
        if (
          selectedInvoiceIsInTransit &&
          typeof onBeforeNavigateToInTransitDetails === 'function'
        ) {
          onBeforeNavigateToInTransitDetails(firstInvoice);
        }
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return {
          opened: false,
          isInTransit: selectedInvoiceIsInTransit,
        };
      } finally {
        this.$f7.preloader.hide();
      }

      this.$f7router.navigate(
        {
          name: 'InvoiceSamplesListDetails',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );

      return {
        opened: true,
        isInTransit: selectedInvoiceIsInTransit,
      };
    },

    deleteAtc(e) {
      try {
        this.$f7.preloader.show();
        const dataGrid = e.component;
        dataGrid.deleteRow(e.row.rowIndex);
        this.deleteInvoice({
          idInvoice: e.row.data.idAlbaran,
          deleteSource: 'invoice_list_delete',
        });
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },

    async GoSampleRegister() {
      try {
        this.trackSamplesRegisterOpen('create_invoice');
        if (this.invoiceSamples.length > 0) {
          this.setInvoiceSamples([]);
        }
        await this.RegisterInvoice();
        this.$f7router.navigate(
          {
            name: 'SamplesRegister',
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },

    async addSampleAtc(e) {
      this.trackSamplesRegisterOpen('add_sample_to_existing_invoice');
      this.setIdInvoice(e.row.data.idAlbaran);
      this.setInvoiceCodeInfoPopUp(e.row.data.CodAlbaran);
      await this.fetchInvoiceSamples(e.row.data.idAlbaran);
      this.$f7router.navigate(
        {
          name: 'SamplesRegister',
          query: {
            mode: 'express',
          },
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },

    async downloadInvoiceAtc(e) {
      try {
        this.$f7.preloader.show();
        await this.generateInvoicePDF(e.row.data.idAlbaran);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(error.message)
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },

    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-simple-toolbar',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      // --- Botón SIN ENVIAR (100) ---
      toolbarItems.push({
        name: 'Sin enviar',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('SamplesList.statusList.pending'),
          icon: '././static/icons/ic_check.svg',
          width: 165,
          elementAttr: {
            class:
              'filtrosBotones ' +
              (this.selectedInvoiceStatuses.includes('100')
                ? 'show-icon'
                : 'hide-icon'),
            'data-tour-id': 'samples-list-status-filter-pending',
          },
          onClick: (ev) => {
            this.toggleStatus('100', ev.element);
          },
        },
      });

      // --- Botón RECEPCIONADAS (102) ---
      toolbarItems.push({
        name: 'Recepcionadas',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('SamplesList.statusList.received'),
          icon: '././static/icons/ic_check.svg',
          width: 165,
          elementAttr: {
            class:
              'filtrosBotones ' +
              (this.selectedInvoiceStatuses.includes('102')
                ? 'show-icon'
                : 'hide-icon'),
            'data-tour-id': 'samples-list-status-filter-received',
          },
          onClick: (ev) => {
            this.toggleStatus('102', ev.element);
          },
        },
      });

      // --- Botón EN TRÁNSITO (101) ---
      toolbarItems.push({
        name: 'En transito',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('SamplesList.statusList.in_transit'),
          icon: '././static/icons/ic_check.svg',
          width: 150,
          elementAttr: {
            class:
              'filtrosBotones ' +
              (this.selectedInvoiceStatuses.includes('101')
                ? 'show-icon'
                : 'hide-icon'),
            'data-tour-id': 'samples-list-status-filter-in-transit',
          },
          onClick: (ev) => {
            this.toggleStatus('101', ev.element);
          },
        },
      });

      toolbarItems.push({
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('registerSample'),
          elementAttr: {
            class: 'botones-registrar',
          },
          onClick: () => {
            this.GoSampleRegister();
          },
        },
      });

      toolbarItems.push({
        name: 'ManageTemplate',
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('manageTemplates'),
          icon: iconDocumentTemplate,
          width: 180,
          elementAttr: { class: 'btn-load-template' },
          onClick: () => {
            this.manageTemplates();
          },
        },
      });

      toolbarItems.push({
        name: 'Por estado',
        location: 'after',
        widget: 'dxSelectBox',
        locateInMenu: 'never',
        visible: false,
        options: {
          placeholder: this.$t('byStatus'),
          icon: '././static/icons/ic_filter.svg',
          elementAttr: {
            class: 'btn-estado',
          },
          dataSource: '',
          displayExpr: '',
          valueExpr: '',
          onValueChanged: () => {},
          dropDownButtonTemplate() {
            return `
          <div class="dropdown-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 14.677C11.8795 14.677 11.7673 14.6577 11.6635 14.6192C11.5597 14.5807 11.4609 14.5147 11.3673 14.4212L6.873 9.927C6.73467 9.7885 6.66384 9.61441 6.6605 9.40475C6.65734 9.19525 6.72817 9.018 6.873 8.873C7.018 8.72816 7.19367 8.65575 7.4 8.65575C7.60634 8.65575 7.782 8.72816 7.927 8.873L12 12.9462L16.073 8.873C16.2115 8.73466 16.3856 8.66383 16.5953 8.6605C16.8048 8.65733 16.982 8.72816 17.127 8.873C17.2718 9.018 17.3443 9.19366 17.3443 9.4C17.3443 9.60633 17.2718 9.782 17.127 9.927L12.6328 14.4212C12.5391 14.5147 12.4403 14.5807 12.3365 14.6192C12.2327 14.6577 12.1205 14.677 12 14.677Z" fill="#00346A"/>
            </svg>
          </div>
      `;
          },
        },
      });
    },

    // ---- StateStoring ----
    loadState() {
      const raw = localStorage.getItem('InvoiceListTable');
      if (!raw) return null;
      const state = JSON.parse(raw);
      state.searchText = '';
      return state;
    },

    customSave(state) {
      // Descomentar para guardar estados de burbuja en grid
      const extendedState = {
        ...state,
        selectedInvoiceStatuses: this.selectedInvoiceStatuses,
      };
      localStorage.setItem(
        'InvoiceListTable',
        JSON.stringify(extendedState)
      );
    },

    init(e) {
      this.grid = e.component;
      Array.from(
        document.getElementsByClassName('dx-group-cell')
      ).forEach((el) => {
        el.innerHTML = el.innerHTML.split(':')[1].trim();
      });
    },

    ...mapActions('samplesRegisterModule', [
      'setSplpopup',
      'setSplPopupTitle',
      'fetchInvoiceSamples',
      'setShowInvoiceInfo',
      'setInvoiceInfo',
      'setInvoiceState',
      'setInvoiceCode',
      'setInvoiceDetails',
      'deleteInvoice',
      'fetchAlbaranes',
      'setIdInvoice',
      'generateInvoicePDF',
      'setInvoiceCodeInfoPopUp',
      'setInvoiceSamples',
      'RegisterInvoice',
    ]),
  },
};
</script>

<style lang="scss">
@import './invoiceList.styles.scss';
</style>
